import BidPolicy from 'Models/policies/BidPolicy'
import Model from './Model'

class Bid extends Model {
  constructor (initialData) {
    super(initialData, {
      momentKeys: [
        'created_at',
        'updated_at',
      ],
    })

    this.policy = new BidPolicy(this)

    // console.log(`Bid ${this.id}`, this)
  }

  get permissionsAgencyId () {
    return parseInt(this.agency_id)
  }

  get permissionsBusinessId () {
    return parseInt(this.business_id)
  }

  get permissionsOwnedByUserId () {
    // TODO: if we don't want this to work at all do we just return null?
    return parseInt(this.user_id)
  }

  // NEW PERMISSION STYLE BEGIN

  get canView () {
    return this.policy.canView
  }

  // NEW PERMISSION STYLE END
}

export default Bid
